import { render, staticRenderFns } from "./right-table.vue?vue&type=template&id=26c75ec1&scoped=true"
import script from "./right-table.vue?vue&type=script&lang=js"
export * from "./right-table.vue?vue&type=script&lang=js"
import style0 from "./right-table.vue?vue&type=style&index=0&id=26c75ec1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c75ec1",
  null
  
)

export default component.exports